import {Component, ElementRef, HostListener, inject, output, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {SearchFilter} from '../../../../services/search.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
  imports: [
    FormsModule
  ]
})
export class FilterComponent {
  private readonly elementRef = inject(ElementRef);
  readonly filterChanged = output<SearchFilter>();

  showFilter = signal(false);

  // Filter options
  filters = signal({
    online: false,
    offline: false,
    overspeeding: false
  });

  // Computed property to count selected filters
  get selectedFiltersCount(): number {
    const currentFilters = this.filters();
    return Object.values(currentFilters).filter(Boolean).length;
  }

  toggleFilterPanel(): void {
    this.showFilter.update(value => !value);
  }

  toggleFilter(filter: 'online' | 'offline' | 'overspeeding'): void {
    this.filters.update(current => ({
      ...current,
      [filter]: !current[filter]
    }));
  }

  resetFilters(): void {
    this.filters.set({
      online: false,
      offline: false,
      overspeeding: false
    });
  }

  // Close filter panel when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Skip if filter panel is not open
    if (!this.showFilter()) return;

    // Check if the click was outside the component
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.showFilter.set(false);
    }
  }

  applyFilters() {
    const { online, offline, overspeeding } = this.filters();
    const shouldSelectAll = online && offline ? 'all' : online;
    this.filterChanged.emit({
      online: shouldSelectAll,
      overspeeding
    });
    this.showFilter.set(false);
  }
}
